//COMPONENTS
import * as ComponentLibrary from "@picnicmedia/masanatemples123";
//TYPES
import { DeleteCreativeModalProps } from "../types";

// Modal to delete selected creative
export function DeleteCreativeModal({ deleteCreativeModal, setDeleteCreativeModal, handleDeleteCreative }: DeleteCreativeModalProps) {
  return (
    <ComponentLibrary.PCDialogueBox
      open={deleteCreativeModal.open}
      width={"width-13"}
      height={"height-7"}
      onClose={() => {
        setDeleteCreativeModal({ open: !deleteCreativeModal.open, creative: "" });
      }}
      hideInitialFocus={true}>
      <p className="text-size-3 platform-color-typography-titles-3 platform-font ma0 fw5">{`Do you want to permanently delete this creative?`}</p>
      <ComponentLibrary.PCSpacer type={"margin"} position={"top"} size={4} />
      <div className="flex justify-left">
        <ComponentLibrary.PCActionButton
          text="Delete Creative"
          textColor={"color-text-5"}
          color={""}
          clickHandler={async (e: any) => {
            await handleDeleteCreative(deleteCreativeModal.creative);
            setDeleteCreativeModal({ open: !deleteCreativeModal.open, creative: "" });
          }}
        />
        <ComponentLibrary.PCSpacer type={"margin"} position={"left"} size={3} />
        <ComponentLibrary.PCActionButton
          text="Go Back"
          textColor={"color-text-5"}
          color={""}
          clickHandler={async (e: any) => {
            setDeleteCreativeModal({ open: !deleteCreativeModal.open, creative: "" });
          }}
        />
      </div>
    </ComponentLibrary.PCDialogueBox>
  );
}
